import angular from 'angular';
import _ from 'lodash';
import BlndTable from 'app/common/table';

import editModalTpl from './templates/edit.modal.html';


class EditProductModal {

    constructor (R, BlndHelpers, $uibModalInstance, $state, object, productRate) {
        "ngInject";
        this.helpers = BlndHelpers;
        this.$modal = $uibModalInstance;
        this.$state = $state;
        this.object = object;
        this.R = R;
        this.productRate = productRate;
        this.data = this.R.copy(this.object);
        this.rateData = this.R.copy(productRate).plain();
        this.errors = {};
        this.state = {}
    }

    get title () {
        return `Edit ${this.object.title}`;
    }

    close () {
        this.$modal.dismiss();
    }

    disableField (field) {
        let idx = this.getFieldIdx(field);

        if (idx === -1) {
            this.data.disabled_fields.push(field);
        } else {
            this.data.disabled_fields.splice(idx, 1);
        }
    }

    getFieldIdx (field) {
        return _.findIndex(this.data.disabled_fields, (o) => {
            return o === field;
        });
    }

    isChecked (field) {
        let idx = this.getFieldIdx(field);
        let isChecked = idx !== -1;
        this.state[field] = isChecked ? 'edit': 'view';
        return isChecked;
    }

    submit () {
        let self = this;
        let readOnlyFields = [
            'description', 'units', 'hazardous_material',
        ];

        let data = this.R.copy(self.data);
        _.each(readOnlyFields, (field) => {
            delete data[field];
        });

        let productPromise = data.put();
        let ratePromise = this.object.customPUT(this.rateData, "rate", {});

        self.errors = {};
        productPromise.then(
            () => {},
            (resp) => { angular.extend(self.errors, resp.data) }
        );
        ratePromise.then(
            () => {},
            (resp) => { self.errors['max_rates'] = resp.data }
        );

        self.helpers.all({
            'product': productPromise,
            'rate': ratePromise
        }).then(
            function (response) {
                let isOk = _.every(_.map(response, function (o) {
                    return (o && o.status) ? !(o.status >= 400) : true;
                }));

                if (!isOk) {
                    return;
                }

                angular.extend(self.object, response.product);
                angular.extend(self.productRate, response.rate);
                self.$state.go('r.in.top.admin.products.list.product', {objectId: response.product.id}, {reload: true});
                self.$modal.close(response.product.id);
            },
        ).finally(() => self.loading = false);
    }
}

export class ProductsCtrl {
    constructor (NgTableParams, $state, $stateParams, $growl, Modal, ProductStore) {
        "ngInject";

        this.Modal = Modal;
        this.$state = $state;
        this.$growl = $growl;
        this.params = {
            is_active: 'yes',
            page_size: 20,
        };
        this.store = ProductStore;

        this.selectedObject = $stateParams.objectId;

        this.table = new BlndTable(NgTableParams, this.store, {
            defaultParams: {
                page_size: 20,
                ordering: ['id', ],
            }
        });
        if ($state.params && $state.params.objectId) {
            this.selectedObject = $state.params.objectId;
        }
    }

    selectRow (objectId) {
        this.selectedObject = objectId;
        this.$state.go('r.in.top.admin.products.list.product', {objectId: objectId});
    }

    refresh () {
        return this.table.refresh(this.params);
    }
}


export class ProductCtrl {
    constructor ($rootScope, Modal, $growl, $object, $productRate) {
        "ngInject";
        this.object = $object;
        this.productRate = $productRate;
        this.$growl = $growl;
        this.Modal = Modal;

        $rootScope.object = this.object;
    }

    isChecked (field) {
        let idx = _.findIndex(this.object.disabled_fields, (o) => {
            return o == field;
        });

        return idx !== -1;
    }

    editModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: editModalTpl,
            controller: EditProductModal,
            size: 'lg',
            resolve: {
                object: () => this.object,
                productRate: () => this.productRate,
            },
        });

        $modal.result.then(function(){
            self.$growl.updated();
        });
    }
}

export class LogCtrl {
    constructor ($rootScope, $object, $productRate) {
        "ngInject";
        this.object = $object;
        this.productRate = $productRate;
        $rootScope.object = this.object;
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/product/ctrls.js